import React, { Component, useRef, useMemo, useState, useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import levenshtein from "js-levenshtein";
import Select from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { getTradeOption } from "../../../../_helpers/tradeOptions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../../../_common/AlertModal";
import { toTitleCase } from "../../../../_utils/generalUtils";
import "./projAdminLabor.css";
import laborActions from "../../../../_actions/laborActions";
import ContractorSelector from "../_common/ContractorSelector";

/**
 * @typedef {Object} LaborNameSuggestion
 * @property {number} levenDistFirst
 * @property {number} levenDistLast
 * @property {number} levenDist - levenDistFirst + levenDistLast
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} fullName
 * @property {number} laborId
 * @property {number} defaultTradeTradeId
 * @property {number} tradeName
 * @property {string} contractorName
 */

class AddLaborModal extends Component {
  state = {
    formData: {
      addedByUserId: null,
      contractorId: null,
      firstName: "",
      lastName: "",
      defaultTradeTradeId: 0,
      selectedTrade: null,
    },
    activeSuggestion: 0,
    /** @type {LaborNameSuggestion[]} */
    suggestions: [],
    chosenLabor: null, // laborDto when a suggested labor is chosen
    laborOptions: [],
    tradeOptions: [],
    formErrors: {},
    showAlert_duplicateWarn: false,
  };

  componentDidMount() {
    const { dispatch, projectId, contractorId } = this.props;
    // document.addEventListener("mousedown", this.handleClick_outsideSuggestions);
    // document.addEventListener(
    //   "touchstart",
    //   this.handleClick_outsideSuggestions
    // );

    dispatch(laborActions.getAll(projectId));

    const selectorOptions = this.getSelectorOptions();
    this.setState({
      ...selectorOptions,
      formData: { ...this.state.formData, contractorId },
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { projLaborList, tradeList } = this.props;
    if (
      (!prevProps.projLaborList && projLaborList) ||
      (!prevProps.tradeList && tradeList)
    ) {
      const selectorOptions = this.getSelectorOptions();
      this.setState({ ...selectorOptions });
    }
  }

  getSelectorOptions = () => {
    const { projLaborList, tradeList } = this.props;

    const laborOptions = [...(projLaborList || [])];
    const tradeOptions = tradeList ? tradeList.map((t) => getTradeOption(t)) : [];

    return { laborOptions, tradeOptions };
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  toggleAlert_duplicateWarn = () =>
    this.setState({ showAlert_duplicateWarn: !this.state.showAlert_duplicateWarn });

  handleChange = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });

  handleChange_firstName = (e) => {
    const { projContractorList, tradeList } = this.props;
    const { formData, laborOptions } = this.state;

    const searchString = e.target.value;

    // First build suggestions based on first name only, then if last name
    // has value, drill down filter.
    /** @type {LaborNameSuggestion[]} */
    let tempSuggestions = [];
    laborOptions.forEach((l) => {
      const trade = tradeList.find((t) => t.tradeId === l.defaultTradeTradeId);
      const tradeName = trade ? trade.title : "(N/A)";

      // Normalize the levenshtein distance by length
      const levenDistFirst = searchString
        ? levenshtein(l.firstName.toLowerCase(), searchString.trim().toLowerCase()) /
          Math.max(l.firstName.length, searchString.length)
        : 0;

      const levenDistLast = formData.lastName
        ? levenshtein(l.lastName.toLowerCase(), formData.lastName.toLowerCase()) /
          Math.max(l.lastName.length, formData.lastName.length)
        : 0;

      const levenDist = levenDistFirst + levenDistLast;

      // Comparing against 2 is very arbitrary - but seems to be reasonable
      if (levenDist < 2)
        tempSuggestions.push({
          levenDistFirst,
          levenDistLast,
          levenDist,
          firstName: l.firstName,
          lastName: l.lastName,
          fullName: l.fullName,
          laborId: l.laborId,
          defaultTradeTradeId: l.defaultTradeTradeId,
          tradeName,
          contractorId: l.contractorId,
          contractorName: projContractorList.find(
            (c) => c.contractorId === l.contractorId
          )?.name,
        });
    });

    const suggestions = _.orderBy(tempSuggestions, "levenDist", "asc");

    this.setState(
      {
        formData: { ...this.state.formData, firstName: searchString },
        activeSuggestion: null,
        suggestions,
        chosenLabor: null, // Whenever nameInput is changed, clear chosenLabor
      },
      () => this.validateForm("firstName")
    );
  };

  handleChange_lastName = (e) => {
    const { projContractorList, tradeList } = this.props;
    const { formData, laborOptions } = this.state;

    const searchString = e.target.value;

    // First build suggestions based on first name only, then if last name
    // has value, drill down filter.
    /** @type {LaborNameSuggestion[]} */
    let tempSuggestions = [];
    laborOptions.forEach((l) => {
      const trade = tradeList.find((t) => t.tradeId === l.defaultTradeTradeId);
      const tradeName = trade ? trade.title : "(N/A)";

      const levenDistFirst = formData.firstName
        ? levenshtein(l.firstName.toLowerCase(), formData.firstName.toLowerCase()) /
          Math.max(l.firstName.length, formData.firstName.length)
        : 0;
      const levenDistLast = searchString
        ? levenshtein(l.lastName.toLowerCase(), searchString.trim().toLowerCase()) /
          Math.max(l.lastName.length, searchString.length)
        : 0;

      const levenDist = levenDistFirst + levenDistLast;
      if (levenDist < 2)
        tempSuggestions.push({
          levenDistFirst,
          levenDistLast,
          levenDist,
          firstName: l.firstName,
          lastName: l.lastName,
          fullName: l.fullName,
          laborId: l.laborId,
          defaultTradeTradeId: l.defaultTradeTradeId,
          tradeName,
          contractorId: l.contractorId,
         contractorName: projContractorList.find(
            (c) => c.contractorId === l.contractorId
          )?.name,
        });
    });

    const suggestions = _.orderBy(tempSuggestions, "levenDist", "asc");

    this.setState(
      {
        formData: { ...this.state.formData, lastName: searchString },
        activeSuggestion: null,
        suggestions,
        chosenLabor: null, // Whenever nameInput is changed, clear chosenLabor
      },
      () => this.validateForm("lastName")
    );
  };

  handleClick_laborSuggestion = (chosenLabor, suggestionIndex) => (e) => {
    const { tradeOptions, formData } = this.state;
    this.setState({
      activeSuggestion: suggestionIndex,
      chosenLabor,
      formData: {
        ...formData,
        contractorId: formData.contractorId,
        firstName: chosenLabor.firstName,
        lastName: chosenLabor.lastName,
        selectedTrade:
          tradeOptions.find((to) => to.value === chosenLabor.defaultTradeTradeId) || null,
        defaultTradeTradeId: chosenLabor.defaultTradeTradeId,
      },
      formErrors: {},
    });
  };

  // handleClick_outsideSuggestions = (e) => {
  //   if (this.wrapperRef && !this.wrapperRef.contains(e.target))
  //     this.setState({
  //       activeSuggestion: 0,
  //       suggestions: [],
  //     });
  // };

  handleChange_select = (fieldName, optionFieldName) => (selectedOption) => {
    const formData = { ...this.state.formData };
    formData[fieldName] = selectedOption.value;
    formData[optionFieldName] = selectedOption;
    // When the contractor selection is changed, we must clear out the
    // chosenLabor as well.
    this.setState({ formData, chosenLabor: null, activeSuggestion: null }, () =>
      this.validateForm(fieldName)
    );
  };

  formIsIncomplete = () => {
    const { formData, formErrors } = this.state;
    return (
      !formData.contractorId ||
      !formData.defaultTradeTradeId ||
      !formData.firstName ||
      !formData.lastName ||
      ("contractor" in formErrors && formErrors.contractor) ||
      ("firstName" in formErrors && formErrors.firstName) ||
      ("lastName" in formErrors && formErrors.lastName) ||
      ("trade" in formErrors && formErrors.trade)
    );
  };

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "firstName":
      case "lastName":
        if (!formData[fieldName]) formErrors[fieldName] = "Required";
        else formErrors[fieldName] = null;
        break;
      case "trade":
        if (formData.selectedTrade == null) formErrors.trade = "Required";
        else formErrors.trade = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  handleClick_submit = async (e) => {
    e.preventDefault();
    const { formData, chosenLabor } = this.state;
    const { projLaborList, toggleAddLaborModal } = this.props;

    // Validate data before closing the modal.
    if (!this.formIsIncomplete()) {
      const matchExists = projLaborList.some(
        (l) =>
          l.contractorId === formData.contractorId &&
          l.firstName.toLowerCase() === formData.firstName.trim().toLowerCase() &&
          l.lastName.toLowerCase() === formData.lastName.trim().toLowerCase() &&
          l.defaultTradeTradeId === formData.defaultTradeTradeId
      );
      if (!chosenLabor && matchExists) this.toggleAlert_duplicateWarn();
      else {
        await this.submitData();
        toggleAddLaborModal();
      }
    }
  };

  handleAlert_duplicateWarn = (action) => async (e) => {
    const { toggleAddLaborModal } = this.props;
    e.preventDefault();
    if (action === "accept") {
      this.toggleAlert_duplicateWarn();
      await this.submitData();
      toggleAddLaborModal();
    } else {
      this.toggleAlert_duplicateWarn();
    }
  };

  submitData = async () => {
    const { chosenLabor, formData } = this.state;
    const { dispatch, projectId, user, projLaborList, dispatchCallback } = this.props;

    /** @type {import('../../_typedefs/globalTypedefs/').LaborDto} */
    const laborData = {
      projectId: projectId,
      addedByUserId: user.userId,
      contractorId: formData.contractorId,
      laborId: chosenLabor ? chosenLabor.laborId : 0,
      firstName: toTitleCase(formData.firstName),
      lastName: toTitleCase(formData.lastName),
      defaultTradeTradeId: formData.defaultTradeTradeId,
    };

    if (!chosenLabor) {
      const newLabor = await dispatch(laborActions.add(laborData));
      dispatchCallback && dispatchCallback(newLabor);
    } else {
      // Check if the chosenLabor exists as part of projLaborList
      const labor = projLaborList.find((l) => l.laborId === chosenLabor.laborId);
      if (labor) {
        dispatchCallback && dispatchCallback(laborData);
      }
    }
  };

  getFullName = () => {
    const { searchString } = this.state;
    const splitName = searchString.trim().split(" ");
    return splitName[0] + splitName[1].charAt(0).toUpperCase() + splitName[2];
  };

  render() {
    const {
      formData,
      formErrors,
      tradeOptions,
      showAlert_duplicateWarn,
      suggestions,
      activeSuggestion,
    } = this.state;
    const { showAddLaborModal, toggleAddLaborModal, projectId } = this.props;

    const closeBtn = (
      <button className="close" onClick={toggleAddLaborModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );

    return (
      <React.Fragment>
        <Modal
          isOpen={showAddLaborModal}
          toggle={toggleAddLaborModal}
          className={this.props.className}
          fade={false}
          size={"lg"}
        >
          <ModalHeader
            toggle={toggleAddLaborModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            Add New Labor
          </ModalHeader>
          <ModalBody>
            <ContractorSelector
              projectId={projectId}
              contractorId={formData.contractorId}
              setContractorId={(contractorId) =>
                this.setState({ formData: { ...this.state.formData, contractorId } })
              }
            />
            <div className="card mx-2">
              <div className="card-body">
                <div className="row mb-2">
                  <div className="col-sm-4 pr-1">
                    <label htmlFor="firstName" className="form-label mb-1">
                      <b>First Name:</b>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      className="form-control"
                      value={formData.firstName}
                      onChange={this.handleChange_firstName}
                      disabled={!formData.contractorId}
                    />
                    {formErrors.firstName && (
                      <span className="error-small">
                        <small>{formErrors.firstName}</small>
                      </span>
                    )}
                  </div>
                  <div className="col-sm-4 px-1">
                    <label htmlFor="lastName" className="form-label mb-1">
                      <b>Last Name:</b>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      className="form-control"
                      value={formData.lastName}
                      onChange={this.handleChange_lastName}
                      disabled={!formData.contractorId}
                    />
                    {formErrors.lastName && (
                      <span className="error-small">
                        <small>{formErrors.lastName}</small>
                      </span>
                    )}
                  </div>
                  <div className="col-sm-4 pl-1">
                    <div className="form-row form-group mb-1">
                      <label htmlFor="addLaborTrade" className="form-label mb-0">
                        <b>Trade:</b>*
                      </label>
                    </div>
                    <div className="form-row from-group">
                      <div className="col-12">
                        <Select
                          name="trade"
                          id="addLaborTrade"
                          value={formData.selectedTrade}
                          options={tradeOptions}
                          onChange={this.handleChange_select(
                            "defaultTradeTradeId",
                            "selectedTrade"
                          )}
                          isDisabled={!formData.contractorId}
                        />
                        {formErrors.trade && (
                          <span className="error-small">
                            <small>{formErrors.trade}</small>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <AddLaborModal_LaborSuggestions
                  suggestions={suggestions}
                  activeSuggestion={activeSuggestion}
                  firstName={formData.firstName}
                  lastName={formData.lastName}
                  handleClick_suggestion={this.handleClick_laborSuggestion}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group mb-0">
              <span className="mr-3 my-auto">
                <small>
                  Further profile details can be entered/edited in the Labor Profile
                  screen.
                </small>
              </span>
              <input
                className="btn btn-primary"
                name="addLabor"
                type="submit"
                form="addLaborForm"
                onClick={this.handleClick_submit}
                value="Add"
                disabled={this.formIsIncomplete()}
              />
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleAddLaborModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
        {showAlert_duplicateWarn && (
          <AlertModal
            alertTitle={"Potential Match Exists"}
            alertTitleIcon="exclamation-triangle"
            alertTitleClass="bg-warning"
            alertText={
              "A labor entry with the same name already exists.\n" +
              "Do you still want to proceed?"
            }
            acceptCaption={"Yes"}
            acceptClass={"primary"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_duplicateWarn}
            showAlertModal={showAlert_duplicateWarn}
            toggleAlertModal={this.toggleAlert_duplicateWarn}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
  projLaborList: state.labors.projLaborLists[ownProps.projectId] || null,
  tradeList: state.feederLists.tradeList || null,
});

export default connect(mapStateToProps)(AddLaborModal);

function AddLaborModal_LaborSuggestions(props) {
  const { suggestions, activeSuggestion, firstName, lastName, handleClick_suggestion } =
    props;
  const isEmpty = useMemo(
    () => !suggestions || (!firstName && !lastName),
    [suggestions, firstName, lastName]
  );
  const liClassName = useRef("list-group-item py-1");

  return (
    <div className="row suggestions">
      <div
        className={`card mx-3 my-0 w-100 ${!isEmpty ? "bg-lightyellow" : "bg-lightgray"}`}
      >
        <div className="card-body p-2">
          <p className="mb-0">
            <b>Potential matches from existing:</b> (Click/tap to add)
          </p>
          {!isEmpty ? (
            <ul
              className="list-group list-group-flush border"
              style={{ backgroundColor: "white" }}
            >
              {suggestions.map((l, index) => (
                <li
                  key={`laborSuggestionKey_${index}`}
                  id={`laborSuggestionId_${index}`}
                  className={`px-1 ${
                    index === activeSuggestion
                      ? liClassName.current + " active"
                      : liClassName.current
                  }`}
                  style={{ zIndex: "0" }}
                  onClick={handleClick_suggestion(l, index)}
                >
                  <div
                    className="d-flex flex-row w-100"
                    id={`laborSuggestionRowId_${index}`}
                  >
                    <div style={{ width: "40%" }} id={`laborSuggestionColId_${index}_0`}>
                      {l.fullName}
                    </div>
                    <div style={{ width: "30%" }} id={`laborSuggestionColId_${index}_1`}>
                      <small id={`laborSuggestionColTextId_${index}_1`}>
                        {l.tradeName}
                      </small>
                    </div>
                    <div style={{ width: "40%" }} id={`laborSuggestionColId_${index}_2`}>
                      <small id={`laborSuggestionColTextId_${index}_2`}>
                        {l.contractorName}
                      </small>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <ul className="list-group list-group-flush border-top border-bottom">
              <li
                key="laborSuggestionKey_none"
                className={liClassName.current + " disabled"}
              >
                No Suggestions
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
